import React from 'react';
import { ChevronDownIcon } from 'lucide-react';
import { Field } from './Field';
import { describedBy, inputClass } from '../../utils/styles';
type SelectFieldProps = {
  id: string;
  label: string;
  value: string;
  options: string[];
  onChange: (value: string) => void;
  required?: boolean;
  hint?: string;
  error?: string;
  className?: string;
};
export function SelectField({
  id,
  label,
  value,
  options,
  onChange,
  required = false,
  hint,
  error,
  className
}: SelectFieldProps) {
  return <Field id={id} label={label} required={required} hint={hint} error={error} className={className} data-id="element-82" data-mp="2nj9vb6j5s1at">
      <div className="relative" data-id="element-83" data-mp="2skz6cm6dseyw">
        <select id={id} name={id} value={value} onChange={e => onChange(e.target.value)} aria-required={required} aria-invalid={Boolean(error)} aria-describedby={describedBy(id, Boolean(hint), Boolean(error))} className={`${inputClass(Boolean(error))} appearance-none pr-10 ${value ? '' : 'text-muted'}`} data-id="element-84" data-mp="2shuwb868ip0b">
          <option value="" data-id="element-85" data-mp="1p10qhvpf1x46">Select…</option>
          {options.map(option => <option key={option} value={option} className="text-ink" data-id="element-86" data-mp="1k6wl3gvstx57">
              {option}
            </option>)}
        </select>
        <ChevronDownIcon className="pointer-events-none absolute right-3.5 top-1/2 h-4 w-4 -translate-y-1/2 text-muted" aria-hidden="true" data-id="element-87" data-mp="1b7t36g8dbnsa" />
      </div>
    </Field>;
}